export default {
    GBR: {
        // Account Routes
        account: '/account',
        confirmation: 'confirmation',
        dashboard: 'dashboard',
        rateMyFlowers: 'rate-my-flowers',
        freeFlowers: 'free-flowers',
        yourBoxesRedirect: 'your-boxes',
        yourBoxes: 'your-boxes',
        deliverySchedule: 'delivery-schedule',
        orderAVase: 'order-a-vase',
        shop: 'shop',
        product: 'shop',
        deliveryAddresses: 'addresses',
        nextWeekDelivery: 'next-week-delivery',
        cardDetails: 'card-details',
        manageAccount: 'manage-account',
        gifting: 'gifting',
        restartConfirmationPage: 'restart-confirmation-page',
        doubleOptinConfirmation: null,
        doubleOptinSpoilerConfirmation: null,
        // Auth Routes
        login: '/login',
        logout: '/logout',
        forgotPassword: '/password/reset',
        resetPasswordNotification: '/password/notification',
        resetPassword: '/password/reset',
        // Content Routes
        jobs: '/jobs',
        privacyPolicy: '/privacy-policy',
        termsAndConditions: '/terms-and-conditions',
        impressum: null,
        paymentAndDelivery: null,
        rightToCancel: null,
        // Coupon Routes
        coupon: '/c',
        // Development Routes
        styleGuide: '/style',
        // FAQ Routes
        faq: '/faq',
        categories: 'categories',
        answers: '*',
        // Gifting Routes
        chooseYourGift: 'choose-your-gift',
        numberOfDeliveries: 'number-of-deliveries',
        deliveryAddress: 'delivery-address',
        freddiesAddons: 'freddies-addons',
        freddiesshop: 'null',
        deliveryDay: 'delivery-day',
        giftCard: 'gift-card',
        payment: 'payment',
        thankYou: 'thank-you',
        // Home Routes
        home: '/',
        theFlowers: '/the-flowers',
        theDelivery: '/the-delivery',
        theArranging: '/the-arranging',
        theIntroductions: '/the-introductions',
        // Recomment a Friend Routes
        referenceFromAFriend: '/r',
        referenceFromWeb: '/r',
        // Register Routes
        register: '/register',
        regAccount: 'account',
        delivery: 'delivery',
        regCardDetails: 'card-details',
        outstandingOrders: 'outstanding-orders',
    },

    DEU: {
        // Account Routes
        account: '/konto',
        confirmation: 'bestatigung',
        dashboard: 'instrumententafel',
        rateMyFlowers: 'meine-blumen-bewerten',
        freeFlowers: 'gratis-blumen',
        yourBoxesRedirect: 'mein-boxen',
        yourBoxes: 'mein-boxen',
        deliverySchedule: 'lieferplan',
        orderAVase: 'vase-bestellen',
        shop: 'shop',
        product: 'shop',
        deliveryAddresses: 'lieferadressen',
        nextWeekDelivery: 'nachste-lieferung',
        cardDetails: 'kreditkartendetails',
        manageAccount: 'mein-konto-verwalten',
        gifting: 'strausse-verschenken',
        restartConfirmationPage: 'neustart-bestatigung',
        doubleOptinConfirmation: 'bestatigung-der-doppeloption',
        doubleOptinSpoilerConfirmation: 'bestatigung-der-spoiler-doppeloption',
        // Auth Routes
        login: '/einloggen',
        logout: '/ausloggen',
        forgotPassword: '/passwort/zurucksetzen',
        resetPasswordNotification: '/passwort/benachrichtigung',
        resetPassword: '/passwort/zurucksetzen',
        // Content Routes
        jobs: '/arbeitsplatze',
        privacyPolicy: '/datenschutz',
        termsAndConditions: '/agb',
        impressum: '/impressum',
        paymentAndDelivery: '/zahlung-und-versand', // linked by path in t&c json line 13
        rightToCancel: '/widerrufsbelehrung', // linked by path in t&c json line 13
        // Coupon Routes
        coupon: '/c',
        // Development Routes
        styleGuide: '/style', // ?????
        // FAQ Routes
        faq: '/faq',
        categories: 'kategorien',
        answers: '*',
        // Gifting Routes
        chooseYourGift: 'wahle-dein-geschenk',
        numberOfDeliveries: 'anzahl-der-lieferungen',
        deliveryAddress: 'lieferadresse',
        freddiesAddons: 'freddies-extras',
        freddiesshop: 'freddies-shop',
        deliveryDay: 'lieferdatum',
        giftCard: 'personalisierte-karte',
        payment: 'zahlung',
        thankYou: 'danke',
        // Home Routes
        home: '/',
        theFlowers: '/die-blumen',
        theDelivery: '/die-lieferung',
        theArranging: '/das-arrangieren',
        theIntroductions: '/die-einfuhrungen',
        // Recomment a Friend Routes
        referenceFromAFriend: '/r',
        referenceFromWeb: '/r',
        // Register Routes
        register: '/register',
        regAccount: 'konto',
        delivery: 'lieferanten',
        regCardDetails: 'kartendetails',
        outstandingOrders: 'outstanding-orders',
    },

    AUT: {
        // Account Routes
        account: '/konto',
        confirmation: 'bestatigung',
        dashboard: 'instrumententafel',
        rateMyFlowers: 'meine-blumen-bewerten',
        freeFlowers: 'gratis-blumen',
        yourBoxesRedirect: 'mein-boxen',
        yourBoxes: 'mein-boxen',
        deliverySchedule: 'lieferplan',
        orderAVase: 'vase-bestellen',
        shop: null,
        product: null,
        deliveryAddresses: 'lieferadressen',
        nextWeekDelivery: 'nachste-lieferung',
        cardDetails: 'kreditkartendetails',
        manageAccount: 'mein-konto-verwalten',
        gifting: 'strausse-verschenken',
        restartConfirmationPage: 'neustart-bestatigung',
        doubleOptinConfirmation: 'bestatigung-der-doppeloption',
        doubleOptinSpoilerConfirmation: 'bestatigung-der-spoiler-doppeloption',
        // Auth Routes
        login: '/einloggen',
        logout: '/logout',
        forgotPassword: '/passwort/zurucksetzen',
        resetPasswordNotification: '/passwort/benachrichtigung',
        resetPassword: '/passwort/zurucksetzen',
        // Content Routes
        jobs: null,
        privacyPolicy: '/datenschutz',
        termsAndConditions: '/agb',
        impressum: '/impressum',
        paymentAndDelivery: '/zahlung-und-versand', // linked by path in t&c json line 13
        rightToCancel: '/widerrufsbelehrung', // linked by path in t&c json line 13
        // Coupon Routes
        coupon: '/c',
        // Development Routes
        styleGuide: '/style', // ?????
        // FAQ Routes
        faq: '/faq',
        categories: 'kategorien',
        answers: '*',
        // Gifting Routes
        chooseYourGift: 'wahle-dein-geschenk',
        numberOfDeliveries: 'anzahl-der-lieferungen',
        deliveryAddress: 'lieferadresse',
        freddiesAddons: 'freddies-extras',
        freddiesshop: 'null',
        deliveryDay: 'lieferdatum',
        giftCard: 'personalisierte-karte',
        payment: 'zahlung',
        thankYou: 'danke',
        // Home Routes
        home: '/',
        theFlowers: '/die-blumen',
        theDelivery: '/die-lieferung',
        theArranging: '/das-arrangieren',
        theIntroductions: '/die-einfuhrungen',
        // Recomment a Friend Routes
        referenceFromAFriend: '/r',
        referenceFromWeb: '/r',
        // Register Routes
        register: '/register',
        regAccount: 'konto',
        delivery: 'lieferanten',
        regCardDetails: 'Kartendetails',
        outstandingOrders: 'outstanding-orders',
    },

    NLD: {
        // Account Routes
        account: '/account',
        confirmation: 'bevestiging',
        dashboard: 'dashboard',
        rateMyFlowers: 'beoordeel-mijn-bloemen',
        freeFlowers: 'gratis-bloemen',
        yourBoxesRedirect: 'jouw-dozen',
        yourBoxes: 'jouw-dozen',
        deliverySchedule: 'leveringsschema',
        orderAVase: 'bestel-een-vaas',
        shop: 'shop',
        product: 'shop',
        deliveryAddresses: 'leveringsadres',
        nextWeekDelivery: 'levering-volgende-week',
        cardDetails: 'kaartgegevens',
        manageAccount: 'beheer-account',
        gifting: 'cadeaus',
        restartConfirmationPage: 'herstart-bevestigingspagina',
        doubleOptinConfirmation: 'dubbele-optin-bevestiging',
        doubleOptinSpoilerConfirmation: 'dubbele-optin-spoiler-bevestiging',
        // Auth Routes
        login: '/inloggen',
        logout: '/uitloggen',
        forgotPassword: '/wachtwoord/reset',
        resetPasswordNotification: '/wachtwoord/notificatie',
        resetPassword: '/wachtwoord/reset',
        // Content Routes
        jobs: '/null',
        privacyPolicy: '/privacybeleid',
        termsAndConditions: '/algemene voorwaarden',
        impressum: '/impressum',
        paymentAndDelivery: '/payment-and-delivery',
        rightToCancel: '/recht-te-annuleren',
        // Coupon Routes
        coupon: '/c',
        // Development Routes
        styleGuide: '/style', // ?????
        // FAQ Routes
        faq: '/faq',
        categories: 'categories',
        answers: '*',
        // Gifting Routes
        chooseYourGift: 'kies-je-cadeau',
        numberOfDeliveries: 'aantal-leveringen',
        deliveryAddress: 'leveringsadres',
        freddiesAddons: 'freddies-addons',
        freddiesshop: 'freddies-shops',
        deliveryDay: 'afleverdag',
        giftCard: 'gift-card',
        payment: 'betaling',
        thankYou: 'bedankt',
        // Home Routes
        home: '/',
        theFlowers: '/de-bloemen',
        theDelivery: '/de-levering',
        theArranging: '/de-arranging',
        theIntroductions: '/de-introducties',
        // Recomment a Friend Routes
        referenceFromAFriend: '/r',
        referenceFromWeb: '/r',
        // Register Routes
        register: '/registratie',
        regAccount: 'account',
        delivery: 'levering',
        regCardDetails: 'kaartgegevens',
        outstandingOrders: 'outstanding-orders',
    },

    USA: {
        // Account Routes
        account: '/account',
        confirmation: 'confirmation',
        dashboard: 'dashboard',
        rateMyFlowers: 'rate-my-flowers',
        freeFlowers: 'free-flowers',
        yourBoxesRedirect: 'your-boxes',
        yourBoxes: 'your-boxes',
        deliverySchedule: 'delivery-schedule',
        orderAVase: 'order-a-vase',
        shop: 'shop',
        product: 'shop',
        deliveryAddresses: 'addresses',
        nextWeekDelivery: 'next-week-delivery',
        cardDetails: 'card-details',
        manageAccount: 'manage-account',
        gifting: 'gifting',
        restartConfirmationPage: 'restart-confirmation-page',
        doubleOptinConfirmation: null,
        doubleOptinSpoilerConfirmation: null,
        // Auth Routes
        login: '/login',
        logout: '/logout',
        forgotPassword: '/password/reset',
        resetPasswordNotification: '/password/notification',
        resetPassword: '/password/reset',
        // Content Routes
        jobs: '/jobs',
        privacyPolicy: '/privacy-policy',
        termsAndConditions: '/terms-and-conditions',
        impressum: '/impressum',
        paymentAndDelivery: '/payment-and-delivery',
        rightToCancel: '/right-to-cancel',
        // Coupon Routes
        coupon: '/c',
        // Development Routes
        styleGuide: '/style',
        // FAQ Routes
        faq: '/faq',
        categories: 'categories',
        answers: '*',
        // Gifting Routes
        chooseYourGift: 'choose-your-gift',
        numberOfDeliveries: 'number-of-deliveries',
        deliveryAddress: 'delivery-address',
        freddiesAddons: 'freddies-addons',
        freddiesshop: 'null',
        deliveryDay: 'delivery-day',
        giftCard: 'gift-card',
        payment: 'payment',
        thankYou: 'thank-you',
        // Home Routes
        home: '/',
        theFlowers: '/the-flowers',
        theDelivery: '/the-delivery',
        theArranging: '/the-arranging',
        theIntroductions: '/the-introductions',
        // Recomment a Friend Routes
        referenceFromAFriend: '/r',
        referenceFromWeb: '/r',
        // Register Routes
        register: '/register',
        regAccount: 'account',
        delivery: 'delivery',
        regCardDetails: 'card-details',
        outstandingOrders: 'outstanding-orders',
    },
};
